import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link, useHistory } from 'react-router-dom';
import { googleLogin, emailRegister } from '../actions/auth';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { Google } from '@mui/icons-material';
import { signInWithGoogle, registerWithEmail } from '../firebase';

const Signup = ({ googleLogin, emailRegister, isAuthenticated, isRegistered }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
    });

    const [passwordError, setPasswordError] = useState('');
    const history = useHistory();
    const { email, password, confirmPassword } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match');
            return;
        }
        setPasswordError('');
        try {
            const user = await registerWithEmail(email, password);
            emailRegister(user);
        } catch (err) {
            setPasswordError('Registration failed. Try a different email.');
        }
    };

    const handleGoogleLogin = async () => {
        try {
            const user = await signInWithGoogle();
            googleLogin(user);
        } catch (err) {
            setPasswordError('Google sign-in failed.');
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            return <Redirect to='/' />;
        } else if (isRegistered) {
            window.alert("You have successfully registered! 🎉");
            history.push('/login');
        }
    }, [isAuthenticated, isRegistered, history]);

    return (
        <Box sx={{ mt: '10px' }}>
            <Grid container sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#F2F2F2', p: 2 }}>
                <Grid item xs={4} sm={4}>
                    <Typography component='h1' variant='h5' align='center' gutterBottom>
                        Sign Up
                    </Typography>
                    <Typography align='center' gutterBottom>
                        Create your Account
                    </Typography>
                    <form onSubmit={onSubmit}>
                        <TextField
                            margin='normal'
                            fullWidth
                            id='email'
                            label='Email*'
                            type='email'
                            name='email'
                            value={email}
                            onChange={onChange}
                            required
                        />
                        <TextField
                            margin='normal'
                            fullWidth
                            id='password'
                            label='Password*'
                            type='password'
                            name='password'
                            value={password}
                            onChange={onChange}
                            minLength='6'
                            required
                        />
                        <TextField
                            margin='normal'
                            fullWidth
                            id='confirmPassword'
                            label='Confirm Password*'
                            type='password'
                            name='confirmPassword'
                            value={confirmPassword}
                            onChange={onChange}
                            minLength='6'
                            required
                            error={passwordError !== ''}
                            helperText={passwordError}
                        />
                        <Button variant='contained' type='submit' fullWidth sx={{ mt: 2 }}>
                            Register
                        </Button>
                    </form>
                    <Typography align='center' sx={{ mt: 3 }}>
                        Already have an account? <Link to='/login'>Sign In</Link>
                    </Typography>
                </Grid>
                <Grid item xs={2} sm={2}></Grid>
                <Grid item xs={3} sm={3}>
                    <Button
                        variant="contained"
                        startIcon={<Google />}
                        style={{ backgroundColor: '#4285F4', color: 'white' }}
                        onClick={handleGoogleLogin}
                    >
                        Sign in with Google
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    isRegistered: state.auth.isRegistered,
});

export default connect(mapStateToProps, { googleLogin, emailRegister })(Signup);